import sidebar from '@/config/sidebars/admin_hubspot'
import createVueApp from '@/common/create_app'

Styxie.Initializers.AdminHubspotSyncLogs = {
  index: async(props) => {
    const { default: SyncLogsIndex } = await import('@/vue_widgets/admin/hubspot/sync_logs/index.vue')
    createVueApp(SyncLogsIndex, { props, sidebar })
  }
}
